import React from "react";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import MaintHero from "../Components/maintenance/MaintHero";
import MaintServices from "../Components/maintenance/MaintServices";
import MaintWhyChoose from "../Components/maintenance/MaintWhyChoose";
import MaintProcessTech from "../Components/maintenance/MaintProcessTech";
import MaintPlans from "../Components/maintenance/MaintPlans";
import MaintCta from "../Components/maintenance/MaintCta";

// Redesigned (Tailwind) page for /service/website-maintenance-support.
const WebsiteMaintenancePage = () => (
  <div>
    <SEOPage
      title="Website Maintenance & Support Services in Noida | DataMetricks"
      description="DataMetricks keeps your website secure, up to date, fast and always accessible with security updates, backups, performance monitoring, bug fixes and dedicated support."
      canonicalUrl="https://www.datametricks.com/service/website-maintenance-support"
    />

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <MaintHero />
      <MaintServices />
      <MaintWhyChoose />
      <MaintProcessTech />
      <MaintPlans />
      <MaintCta />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default WebsiteMaintenancePage;
